<div class="flex">
  <div>
    <div class="severity-bg-icon icon-severity-3"></div>
    @switch (severity()) {
      @case (eIncidentSeverity.CRITICAL) {
        <div class="status-icon icon-severity-3 critical"></div>
      }
      @case (eIncidentSeverity.MAJOR) {
        <div class="status-icon icon-severity-2 critical"></div>
      }
      @case (eIncidentSeverity.MINOR) {
        <div class="status-icon icon-severity-1 warning"></div>
      }
      @default {
        <div class="status-icon icon-severity-3"></div>
      }
    }
  </div>
  @if (showLabel()) {
    <div class="capitalize -mt-0.5 pl-2">{{ severity() }}</div>
  }
</div>
